import { useGame } from "./GameContext";
import { PICE_ARR } from "./hintData";

export default function HintDetail() {
  const { hintIndex, openHint } = useGame();
  const data = PICE_ARR[hintIndex];

  if (!data) return null;

  const { title, content, status, keyText } = data;

  return (
    <div className="hint_detail box_con con_box7 con_box_storage con_box_storage02">
      <div className="missionDiv">
        <div className="missionDi">
          <div className="mission_content pdTB65120 hintDetail_div">
            <p className="storage_tit storage_tit_d mb8">{title}</p>

            <p
              className="storage_txt storage_txt_d"
              dangerouslySetInnerHTML={{ __html: content }}
            />

            {status === "ok" && (
              <p className="storage_txt2 mt12 storage_txt2_d">{keyText}</p>
            )}

            {/* 확인 버튼 → 리스트 */}
            <div id="box_ft3" className="mt16">
              <button className="inputBtn02" onClick={openHint}>
                확인
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
